import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';
import { isAdminDashboard } from 'utils/authScopes';
import { ASQ_RESULT_COLUMNS } from 'utils/asqResultColumns';

const GroupCohortsHeader = ({ ages, auth, meta }) => {
  const { t } = useTranslation();
  const headers = meta.withages ? map(ages, a => <th key={a.value}>{a.label}</th>) : null;
  return (
    <thead>
      <tr>
        { isAdminDashboard(auth) && <th>{t('groupCohortsReport.columns.partner')}</th> }
        <th>{t('groupCohortsReport.columns.group')}</th>
        { meta.withcohorts &&(
          <>
            <th>{t('groupCohortsReport.columns.subgroup')}</th>
            <th>{t('groupCohortsReport.columns.cohort')}</th>
          </>
        )
        }
        <th>{t('groupCohortsReport.columns.numberOfChildren')}</th>
        { headers }
        <th>{t('groupCohortsReport.columns.activeChildren')}</th>
        <th>{t('groupCohortsReport.columns.engagedChildren')}</th>
        <th>{t('groupCohortsReport.columns.completedAsqSe2')}</th>
        <th>{t('groupCohortsReport.columns.completedAsq3')}</th>
        <th>{t('groupCohortsReport.columns.numberOfPlays')}</th>
        <th>{t('groupCohortsReport.columns.numberOfPhotos')}</th>
        { meta.withasq && ASQ_RESULT_COLUMNS.map(({ column }) => (
          <th key={column}>{t(`groupCohortsReport.columns.${column}`)}</th>
        )) }
      </tr>
    </thead>
  );
}

GroupCohortsHeader.propTypes = {
  ages: PropTypes.arrayOf(PropTypes.object).isRequired,
  auth: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default GroupCohortsHeader;
